import actions from './actions';

const {
  ADD_TOP_CAR_SALES_BEGIN,
  ADD_TOP_CAR_SALES_FAILED,
  ADD_TOP_CAR_SALES_SUCCESS,
  DELETE_FUEL_PRICE_BEGIN,
  DELETE_FUEL_PRICE_FAILED,
  DELETE_FUEL_PRICE_SUCCESS,
  GET_TOP_CAR_SALES_BEGIN,
  GET_TOP_CAR_SALES_FAILED,
  GET_TOP_CAR_SALES_SUCCESS,
  UPDATE_TOP_CAR_SALES_BEGIN,
  UPDATE_TOP_CAR_SALES_FAILED,
  UPDATE_TOP_CAR_SALES_SUCCESS,
} = actions;

const initState = {
  topCarSales: [],
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null,
};

const TopCarSalesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_TOP_CAR_SALES_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_TOP_CAR_SALES_SUCCESS:
      return {
        ...state,
        topCarSales: data.topCarSales,
        total: data.total,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_TOP_CAR_SALES_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_TOP_CAR_SALES_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_TOP_CAR_SALES_SUCCESS:
      return {
        ...state,
        topCarSales: data,
        loading: false,
      };
    case ADD_TOP_CAR_SALES_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_TOP_CAR_SALES_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_TOP_CAR_SALES_SUCCESS:
      return {
        ...state,
        topCarSales: data,
        loading: false,
      };
    case UPDATE_TOP_CAR_SALES_FAILED:
      return {
        ...state,
        err,
        loading: false,
      };
    case DELETE_FUEL_PRICE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_FUEL_PRICE_SUCCESS:
      return {
        ...state,
        topCarSales: data,
        loading: false,
      };
    case DELETE_FUEL_PRICE_FAILED:
      return {
        ...state,
        err,
        loading: false,
      };
    default:
      return state;
  }
};

export default TopCarSalesReducer;